import { useEffect, useState } from "react";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import { useI18n } from "@/lib/i18n";
import { Clock, Users, ChefHat } from "lucide-react";

export default function Recipes() {
  const { lang } = useI18n();
  const [recipes, setRecipes] = useState([]);
  useEffect(() => { api.get("/recipes").then((r) => setRecipes(r.data)); }, []);

  return (
    <div className="min-h-screen overflow-x-hidden">
      <Header />
      <section className="pt-32 pb-16 px-6 md:px-12 lg:px-20" data-testid="recipes-page">
        <Reveal>
          <div className="max-w-3xl">
            <div className="eyebrow text-[var(--dsf-orange)] mb-3">{lang === "fr" ? "Recettes" : "Recipes"}</div>
            <h1 className="font-serif text-5xl md:text-7xl text-[var(--dd-green)] leading-[1.02] mb-6">
              {lang === "fr" ? "Nos recettes." : "Our recipes."}
            </h1>
          </div>
        </Reveal>
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {recipes.map((r, i) => (
            <Reveal key={i} delay={i * 100}>
              <a href="#" className="block group card-light hover:border-[var(--dsf-green)] transition-colors" data-testid={`recipe-${r.slug}`}>
                <div className="aspect-[16/9] overflow-hidden">
                  <img src={r.image} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <h3 className="font-serif text-3xl text-[var(--dd-green)] font-semibold mb-4">{lang === "fr" ? r.title : r.title_en}</h3>
                  <div className="flex items-center gap-6 text-sm text-[var(--dsf-text-secondary)]">
                    <div className="flex items-center gap-1.5"><Clock size={14} /> {r.time} min</div>
                    <div className="flex items-center gap-1.5"><Users size={14} /> {r.servings}</div>
                    <div className="flex items-center gap-1.5"><ChefHat size={14} /> {r.difficulty}</div>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
